import { createStore } from 'vuex'
import router from '@/router/index'
import axios from '../util/axios'
import util from '../util/util'
import tool from '../util/tool'

export default createStore({
  state () {
    return {
      token: JSON.parse(tool.session.get("crmToken")),
      // token: JSON.parse(localStorage.getItem("crmToken")),
      user: null,
      imageServer:null,
      from:null,
      dark:localStorage.getItem('isDark')==='1',
      title:'',
      editDialogs:[],
      refreshPages:[],
        unReadCount: {},

    }
  },
  mutations: {
    unReadCount(state, unReadCount) {
        state.unReadCount = unReadCount
    },

    setEditDialogs(state,dialogs){
      state.editDialogs = dialogs;
    },
    setFrom(state,from){
      state.from = from
    },
    setTitle(state,title){
      state.title = title
    },
    setToken(state, result) {
      state.token = result
        //pc上的企业微信localStorage 退出后就清空了
        tool.session.set("crmToken",JSON.stringify(result))
        // localStorage.setItem('crmToken', JSON.stringify(result));
    },
    logout(state,toLogin=true){
      state.token = null;
      tool.session.clear("crmToken")
        // localStorage.removeItem('crmToken');
      state.user=null;
      if(toLogin){
        router.replace("/login")
      }
    },
    setImageServer(state,imageServer){
      state.imageServer=imageServer;
    },
    setUser(state, user) {
      state.user = user;
      this.dispatch('getUnReadCount')
    },
    addRefreshPages(state, page){
      let item = state.refreshPages.find(item=>{
        return item == page;
      })
      if(item==null){
        state.refreshPages.push(page)
      }
    }
  },
  getters: {
    from:(state)=>{
      return state.from;
    },
    getEditDialogs:(state)=>{
      return state.editDialogs;
    },
    getRefreshPages:(state)=>{
      return state.refreshPages;
    },
    isNeedRefreshPage:(state)=>{
      let index = state.refreshPages.findIndex(item=>{
        return item == router.currentRoute.value.name;
      })
      let needRefresh = index>-1;
      if(needRefresh){
        state.refreshPages.splice(index,1)
      }
      return needRefresh;
    },
    token:(state)=>{
      if(state.token){
        let currTime=new Date().getTime();
        if(state.token.expiresAt<=currTime){
          state.token = null;
        }
        return state.token;
      }else{
        return null;
      }
    },
    title:(state)=>{
      if(state.title){
        return state.title;
      }else {
        if (state.user) {
          return state.user.currOrg?.$label;
        }
        else{
          return "汇客厅CRM"
        }
      }
    },
    user:(state)=>{
      return state.user;
    },
    isLogin:(state)=>{
      return !!state.token;
    },
  },
  actions: {
      async getUnReadCount({ commit, state }) {
          try {
              // console.log("@@",this,axios)
              const result = await axios.exeQuery('Message','unReadCount')
              commit('unReadCount', result||{})
          } catch (e) {
              // console.log(e)
              commit('unReadCount', {})
          }
      },
      async getCurrAccount({ commit, state }) {
          try{
              let user=await axios.get("/account/curr");
              if(user){
                  commit("setUser",user)
              }else{
                  commit('logout')
              }
          }catch(e){
              util.error(e)
              commit('logout')
          }
      },
  }
})

